import { render, staticRenderFns } from "./StatsKpiCards.vue?vue&type=template&id=2072bb63&scoped=true"
import script from "./StatsKpiCards.vue?vue&type=script&lang=js"
export * from "./StatsKpiCards.vue?vue&type=script&lang=js"
import style0 from "./StatsKpiCards.vue?vue&type=style&index=0&id=2072bb63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2072bb63",
  null
  
)

export default component.exports